import React from 'react';
import './style.scss';
import TeamComponent from './teamStar';

const LandingFooterTeam = () => (
  <section id='team' className='landing-footer-section-team'>
    <div className='lfst-desc'>
      <h2 className='lfst-desc-wording'>team</h2>
      <p className='body-1'>
        Meet our nifty team. We are gamers, designers and developers from around
        the world.
      </p>
    </div>
    <TeamComponent />
  </section>
);

export default LandingFooterTeam;
